import React from "react";
import {
  BarChart,
  // Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  // CartesianGrid,
  Bar,
  Label,
  // Area,
  ResponsiveContainer,
} from "recharts";

const BarGraph = ({ datum }) => {
  const data = datum?.data?.deposits?.map(({ name, MPesa, Payroll }) => ({
    name,
    MPesa,
    "Check-off": Payroll,
  }));
  return (
    <ResponsiveContainer>
      <BarChart width={500} height={200} data={data} margin={{ left: 10 }}>
        <XAxis dataKey="name" axisLine={{ stroke: "#D9D9D9" }} />
        <YAxis axisLine={{ stroke: "#D9D9D9" }}>
          <Label value="Amount" angle={-90} offset={-5} position="insideLeft" />
        </YAxis>
        <Tooltip />
        <Legend />
        <Bar dataKey="MPesa" fill="#074073" />
        <Bar dataKey="Check-off" fill="#19C1E4" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarGraph;
